import Axios from '../../config/axios';

export async function refreshToken(postdata) {
    const response = await Axios.post('/api/refreshToken', postdata);

    return response.data;
}